// TOUR-13b — KB article authoring (Manager bucket; distinct from browse tour).

import type { FireflyTourArtifact } from "../tourTypes";

export const KB_AUTHOR_TOUR_ID = "tour-kb-author";

export const KB_AUTHOR_TOUR: FireflyTourArtifact = {
  id: KB_AUTHOR_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "kb author tour",
    "how do i add a kb article",
    "add a kb article",
    "create kb article",
    "write a knowledge base article",
    "kb article tour",
    "publish kb article",
  ],
  bucketRelevance: ["manager"],
  requiredRoles: ["trainer", "admin", "owner"],
  requiredCapabilities: ["is_kb_author"],
  steps: [
    {
      id: "nav-knowledgebase",
      target: {
        mode: "knowledgebase",
        anchorId: "mode-nav-knowledgebase",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "knowledgebase",
      copy: {
        title: "Open Knowledge Base",
        body: "Authors draft and publish org KB articles here under Manager. Tap Knowledge Base in the sidebar (or bottom bar on mobile).",
      },
      waitForClick: true,
    },
    {
      id: "kb-workspace",
      target: { mode: "knowledgebase", anchorId: "kb-workspace", scrollIntoView: true },
      copy: [
        {
          roles: ["trainer"],
          title: "Author workspace",
          body: "Trainers create drafts and change proposals. Admins with publish access promote drafts live — check the publish access badge in the header.",
        },
        {
          roles: ["admin", "owner"],
          title: "Author workspace",
          body: "Publish access lets you save live articles and approve trainer proposals. Draft-only authors still search and propose from Library.",
        },
      ],
      advanceOn: "next_button",
    },
    {
      id: "new-article",
      target: { mode: "knowledgebase", anchorId: "kb-new-article", scrollIntoView: true },
      copy: {
        title: "New article",
        body: "Tap New article to clear the editor and start a fresh draft — or open the Editor tile if you already have a loaded article.",
      },
      waitForClick: true,
    },
    {
      id: "editor-panel",
      target: { mode: "knowledgebase", anchorId: "kb-editor-panel", scrollIntoView: true },
      copy: {
        title: "Editor",
        body: "Set title, audience, scope, and body copy. Use AI assist when helpful — then scroll to the save section when the draft is ready.",
      },
      advanceOn: "next_button",
    },
    {
      id: "editor-save",
      target: { mode: "knowledgebase", anchorId: "kb-editor-save", scrollIntoView: true },
      copy: [
        {
          roles: ["trainer"],
          title: "Save draft",
          body: "Save or create stores a draft proposal. Published org articles stay locked until an admin approves your change proposal.",
        },
        {
          roles: ["admin", "owner"],
          title: "Save or publish",
          body: "Save or create persists the article. With publish access, new org articles can go live immediately; edits to published articles may still flow through proposals.",
        },
      ],
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "knowledgebase", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Need to search existing articles instead? Ask for the knowledge base browse tour. Reps consume KB answers from Training and Ads surfaces.",
      },
      advanceOn: "next_button",
    },
  ],
};
